import React from 'react';
import { PXFormModalWrapper } from 'Views/Page/Content/Modal/Layouts/PXFormModalWrapper';
import FacetPlanSearchableFieldLayout from 'Views/Page/Content/Modal/Layouts/FacetPlanSearchableFieldFormLayout/Layout';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';

const Layout = () => {
  useBoneBackgroundColor();
  return (
    <PXFormModalWrapper>
      <FacetPlanSearchableFieldLayout
        sections={[
          {
            section: 'Account Selection',
            fields:
              ['virtualAccount'],
          },
          {
            section: 'Member Contribution',
            description: 'How much can the member contribute to this strategy?',
            fields: [
              'contributionLimitRules',
              'accountSubTypes',
              'defaultAnnualContributionLimit',
              'contributionLimitChanges',
              'contributionLimits',
              'hasIncomeBasedContributionLimit',
              'percentOfIncomeContributionLimit',
              'hasCatchUpContributions',
              'catchUpContributionLimits',
              'contributionLimitInflationRate',
              'targetAnnualContribution',
              'contributionStartDate',
              'contributionEndDate',
              'contributionsTaxationType',
            ],
          },
          {
            section: 'Employer Contributions',
            description: 'How much can the employer contribute to this strategy?',
            fields: [
              'hasEmployerMatch',
              'hasNonElectiveEmployerMatch',
              'nonElectiveMatchEmployerMatchPercentage',
              'employerMatchSelectedIncome',
              'electiveEmployerMatchingRules',
              'employerMatchContributionLimits',
            ],
          },
          {
            section: 'Withdrawals',
            fields: [
              'withdrawalPeriodStart',
              'withdrawalStartDate',
              'withdrawalStartAtAge',
              'hasRMDs',
              'withdrawalTaxationType',
              'fixedWithdrawals',
            ],
          },
          {
            section: 'Income',
            fields: [
              'generatedIncome',
            ],
          },
          {
            section: 'Expenses',
            fields: [
              'generatedExpenses',
            ],
          },
        ]}
      />
    </PXFormModalWrapper>
  );
};

export default Layout;
